export const COMMON_ROOM_TEXT = {
  defaultAriaLabel: 'Post',
  pinnedPost: 'This is a pinned post',
  recentlyPinnedPost: 'This is a recently pinned post',
  edited: '(Edited)',
  tagsSection: 'Post tags',
  reactionsSection: 'Post reactions',
  commentsSection: 'Post comments and replies',
  postOptions: 'Post options',
  deletePostTitle: 'Delete post',
  closeDeleteDialog: 'Close delete assignment dialog',
  deletePostConfirmation: 'Are you sure that you want to delete this post? ',
};

export const ANNOUNCEMENTS_TEXT = {
  defaultAriaLabel: 'Post',
  pinnedPost: 'This is a pinned post',
  recentlyPinnedPost: 'This is a recently pinned post',
  edited: '(Edited)',
  tagsSection: 'Post tags',
  reactionsSection: 'Post reactions',
  commentsSection: 'Post comments and replies',
  postOptions: 'Post options',
  deletePostTitle: 'Delete post',
  closeDeleteDialog: 'Close delete assignment dialog',
  deletePostConfirmation: 'Are you sure that you want to delete this post? ',
};

export const CANCEL = 'Cancel';
export const DELETE = 'Delete';
export const CLOSE = 'Close';
